import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created — welcome.");
      navigate(next && next.startsWith("/") ? next : "/membership");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not create account.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <div className="overline mb-3">Join the ministry</div>
      <h1 className="font-serif-display text-4xl tracking-tight" style={{ color: "var(--ink)" }}>Create your account</h1>
      <p className="mt-3 text-sm" style={{ color: "var(--ink-2)" }}>
        Free to register. Becoming a member is a separate step.
      </p>
      <form onSubmit={onSubmit} className="mt-8 space-y-5">
        <div>
          <label className="block text-xs mb-2 overline">Name</label>
          <input
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="register-name-input"
            className="w-full bg-white border px-4 py-3 outline-none focus:border-[var(--terracotta)]"
            style={{ borderColor: "var(--border-strong)", color: "var(--ink)" }}
          />
        </div>
        <div>
          <label className="block text-xs mb-2 overline">Email</label>
          <input
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="register-email-input"
            className="w-full bg-white border px-4 py-3 outline-none focus:border-[var(--terracotta)]"
            style={{ borderColor: "var(--border-strong)", color: "var(--ink)" }}
          />
        </div>
        <div>
          <label className="block text-xs mb-2 overline">Password</label>
          <input
            type="password"
            required
            minLength={6}
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="register-password-input"
            className="w-full bg-white border px-4 py-3 outline-none focus:border-[var(--terracotta)]"
            style={{ borderColor: "var(--border-strong)", color: "var(--ink)" }}
          />
        </div>
        <button type="submit" disabled={busy} data-testid="register-submit-button" className="btn-primary w-full justify-center disabled:opacity-50">
          {busy ? "Creating…" : "Create account"}
        </button>
      </form>
      <p className="mt-8 text-sm" style={{ color: "var(--ink-2)" }}>
        Already have an account? <Link to="/login" data-testid="register-login-link" className="underline" style={{ color: "var(--terracotta)" }}>Sign in</Link>
      </p>
    </div>
  );
}
